/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {editUserSelector} from '../store/selectors/admin-users-selectors';

/**
 * The usePreferenceRefresh is responsible for do re-rendering the component which
 * invoking this hook whenever there is a change in the current user state
 * (updating the current user / change in profile).
 *
 * ```typescript
 *
 *  import {usePreferenceRefresh} from '../../hooks/usePreferenceRefresh';
 *
 *  const refresh = usePreferenceRefresh();
 *
 * ```
 */
export const usePreferenceRefresh = (): boolean => {
  const [refresh, setRefresh]   = useState(false);
  const {isCurrentUser, result} = useSelector(editUserSelector);

  useEffect(() => {
    if (isCurrentUser && !!result) {
      setRefresh(true);
      const timeout = setTimeout(() => {
        setRefresh(false);
        clearTimeout(timeout);
      }, 500);
    }
  }, [isCurrentUser, result]);

  return refresh;
};

export default usePreferenceRefresh;
